import {
    type ClientReferrerInformation,
    MarketingReferralConstants,
} from '../../../../shared/marketing_ad_compaign/MarketingReferralConstants.ts'
import {socket} from '../EntryShared.ts'
import {SocketLobbySend} from '../socket/SocketLobbySend.ts'
import {LobbyAction} from '@colonist/lobby-types'

enum TabCommunicationEvents {
    RequestSessionReferrer = 'requestSavedReferrer',
    SessionReferrerDataPackage = `sendSessionReferrer`,
    RequestSessionReferralCode = 'requestSessionReferralCode',
    SessionReferralDataPackage = 'sendSessionReferralCode',
}
export class UIReferralController {
    private static readonly REFERRER_KEY = 'referrer'
    private static readonly REFERRAL_CODE_KEY = 'referralCode'

    static init() {
        this.initVariables()
        // This is a hack to allow tabs to share information between them.
        // The appraoch is documented here: https://medium.com/@marciomariani/sharing-sessionstorage-between-tabs-5b6f42c6348c
        window.addEventListener('storage', (event) => {
            if(typeof event.key != 'string') return
            if(event.newValue == null) return
            switch(event.key as string) {
                case TabCommunicationEvents.RequestSessionReferrer: this.sendSessionReferrer(); break
                case TabCommunicationEvents.SessionReferrerDataPackage: this.updateSessionReferrer(event.newValue); break
                case TabCommunicationEvents.RequestSessionReferralCode: this.sendSessionReferralCode(); break
                case TabCommunicationEvents.SessionReferralDataPackage: this.updateSessionReferralCode(event.newValue); break
            }
        })

        this.requestSavedReferrerFromOtherOpenTabs()
        this.requestSavedReferralCodeFromOtherOpenTabs()

        socket.controller.registerSessionEstablishedObserver(() => {
            const referrer = this.referrer
            const referralCode = this.referralCode
            const referrerInformation: ClientReferrerInformation = {
                referrer: referrer == '' ? undefined : referrer,
                referralCode: referralCode ?? undefined,
            }

            if(!MarketingReferralConstants.isReferrerInformationEmpty(referrerInformation)) {
                SocketLobbySend.sendLobby(LobbyAction.SaveClientReferrer, referrerInformation)
            }
        })
    }

    private static initVariables() {
        const callReferrerToInit = this.referrer
        const callReferralCodeToInit = this.referralCode
    }

    private static requestSavedReferrerFromOtherOpenTabs() {
        // This is a hack to communitcate between tabs.
        // The other tab is listening for any events where the storage is changed.
        // So by adding/removing an item it acts as a form of communication between tabs.
        // Source: https://medium.com/@marciomariani/sharing-sessionstorage-between-tabs-5b6f42c6348c
        window.localStorage.setItem(TabCommunicationEvents.RequestSessionReferrer, '')
        window.localStorage.removeItem(TabCommunicationEvents.RequestSessionReferrer)
    }

    private static sendSessionReferrer() {
        const sessionReferrer = this.getSessionReferrer()
        if(sessionReferrer == null) return
        // This is a hack to communitcate between tabs.
        // The other tab is listening for any events where the storage is changed.
        // So by adding/removing an item it acts as a form of communication between tabs.
        // Source: https://medium.com/@marciomariani/sharing-sessionstorage-between-tabs-5b6f42c6348c
        window.localStorage.setItem(TabCommunicationEvents.SessionReferrerDataPackage, sessionReferrer)
        window.localStorage.removeItem(TabCommunicationEvents.SessionReferrerDataPackage)
    }

    private static updateSessionReferrer(referrer: string | null) {
        if(referrer == null) return
        this.referrer = referrer
    }

    private static requestSavedReferralCodeFromOtherOpenTabs() {
        // This is a hack to communitcate between tabs.
        // The other tab is listening for any events where the storage is changed.
        // So by adding/removing an item it acts as a form of communication between tabs.
        // Source: https://medium.com/@marciomariani/sharing-sessionstorage-between-tabs-5b6f42c6348c
        window.localStorage.setItem(TabCommunicationEvents.RequestSessionReferralCode, '')
        window.localStorage.removeItem(TabCommunicationEvents.RequestSessionReferralCode)
    }

    private static sendSessionReferralCode() {
        const sessionReferralCode = this.getSessionReferralCode()
        if(sessionReferralCode == null) return
        // This is a hack to communitcate between tabs.
        // The other tab is listening for any events where the storage is changed.
        // So by adding/removing an item it acts as a form of communication between tabs.
        // Source: https://medium.com/@marciomariani/sharing-sessionstorage-between-tabs-5b6f42c6348c
        window.localStorage.setItem(TabCommunicationEvents.SessionReferralDataPackage, sessionReferralCode)
        window.localStorage.removeItem(TabCommunicationEvents.SessionReferralDataPackage)
    }

    private static updateSessionReferralCode(referralCode: string | null) {
        if(referralCode == null) return
        this.referralCode = referralCode
    }

    static get referrer(): string {
        const sessionReferrer = this.getSessionReferrer()
        if(sessionReferrer != null) return sessionReferrer

        const newReferrer = document.referrer
        this.referrer = newReferrer
        return newReferrer
    }

    private static set referrer(value: string) {
        sessionStorage.setItem(this.REFERRER_KEY, value)
    }

    private static getSessionReferrer(): string | null {
        return sessionStorage.getItem(this.REFERRER_KEY)
    }

    static get referralCode(): string | null {
        const sessionReferralCode = this.getSessionReferralCode()
        if(sessionReferralCode != null) return sessionReferralCode

        const newSessionReferralCode = this.getReferralCodeFromURL()
        if(newSessionReferralCode == null) return null
        this.referralCode = newSessionReferralCode
        return newSessionReferralCode
    }

    private static set referralCode(value: string | null) {
        if(value == null) return
        sessionStorage.setItem(this.REFERRAL_CODE_KEY, value)
    }

    private static getSessionReferralCode(): string | null {
        return sessionStorage.getItem(this.REFERRAL_CODE_KEY)
    }

    private static getReferralCodeFromURL(): string | null {
        const urlSearchParams = new URLSearchParams(window.location.search)
        const referrralCode = urlSearchParams.get(MarketingReferralConstants.marketingReferralCodeURLVariable)
        return referrralCode
    }
}
